<template lang="pug">
fragment
  dt(style="background-color: cornsilk;")
    | 事前アンケート
  dd(style="background-color: cornsilk;")
    | 映像制作についてのアンケートにお答えください
  dt.required
    | 動画のSNS発信を行っていますか？
  dd
    div
      validation-provider(rules="required" name="動画のSNS発信" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(yn, i) in yesNo" :key="i")
            input(type="radio" v-model="enquete.video_sns_outgoing" :value="yn" :id="`video_sns_outgoing-${i}`")
            label(:for="`video_sns_outgoing-${i}`")
              | {{ yn }}

  dt(:class="enquete.video_sns_outgoing === 'はい' ? 'required' : 'optional'")
    | 発信している主なSNSは何ですか？最も使用しているものを1つ選択してください
  dd
    div
      validation-provider(:rules="{ required: enquete.video_sns_outgoing === 'はい' }" name="発信している主なSNS" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
            | 上の設問で「はい」と回答した方のみ
          .v-radio(v-for="(sns, i) in snss" :key="i")
            input(type="radio" v-model="enquete.sns_main_outgoing" :value="sns" :id="`sns_main_outgoing-${i}`")
            label(:for="`sns_main_outgoing-${i}`")
              | {{ sns }}
            template(v-if="sns === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`sns_main_outgoing-${i}`) && enquete.video_sns_outgoing === 'はい' }" name="その他のSNS" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.sns_main_outgoing_other" :class="{ error: invalid && validated }")

  dt.required
    | 最も使用頻度が高い撮影機材を1つ選択してください
  dd
    div
      validation-provider(rules="required" name="撮影機材" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(equipment, i) in equipments" :key="i")
            input(type="radio" v-model="enquete.shooting_equipment" :value="equipment" :id="`shooting_equipment-${i}`")
            label(:for="`shooting_equipment-${i}`")
              | {{ equipment }}
            template(v-if="equipment === 'その他'")
              validation-provider(:rules="{ required: isOtherRequired(`shooting_equipment-${i}`) }" name="その他の撮影機材" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
                .error-message(v-if="errors[0]" v-html="errors[0]")
                input(type="text" v-model="enquete.shooting_equipment_other" :class="{ error: invalid && validated }")

  dt(:class="enquete.shooting_equipment === 'ミラーレスカメラ' ? 'required' : 'optional'")
    | 主な使用カメラのメーカー名／品番を記載してください
  dd
    div
      validation-provider(:rules="{ required: enquete.shooting_equipment === 'ミラーレスカメラ' }" name="主な使用カメラのメーカー名／品番" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .caption
            | 上の設問で「ミラーレスカメラ」と回答した方のみ
          .job-form-point
            | 例：Nikon Z 30、SONY VLOGCAM ZV-E1、Canon EOS Kiss X90など
          textarea(id="camera_maker" v-model="enquete.camera_maker")

  dt.optional
    | 発信しているSNSアカウントを記載してください
  dd
    div
      validation-provider(rules="" name="SNSアカウント" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'is-error': invalid && validated }")
          .job-form-point
            | 例：
            br
            | instagramの場合：https://www.instagram.com/vookschool/
            br
            | Twitterの場合：https://twitter.com/VookJp
            br
            | Facebookの場合：https://www.facebook.com/VookJp/
            br
            | YouTubeの場合：https://www.youtube.com/channel/UCwQ0VT8WWOT5Nvcg5Q43zxA　など
          textarea(id="sns_account" v-model="enquete.sns_account")

  dt.required
    | 今回のウェビナーで最も聞きたい内容を1つ選択してください
  dd
    div
      validation-provider(rules="required" name="最も聞きたい内容" v-slot="{ errors, invalid, validated }")
        .error-message(v-html="errors[0]")
        div(:class="{ 'checkbox-error': invalid && validated }")
          .v-radio(v-for="(content, i) in contents" :key="i")
            input(type="radio" v-model="enquete.listen_detail" :value="content" :id="`listen_detail-${i}`")
            label(:for="`listen_detail-${i}`")
              | {{ content }}

</template>

<script>
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const YES_NO = ['はい', 'いいえ']

const SNSS = [
  'instagram',
  'YouTube',
  'twitter',
  'TikTok',
  'Facebook',
  'LINE',
  'その他'
]

const EQUIPMENTS = ['スマートフォン', 'ミラーレスカメラ', 'その他']

const CONTENTS = [
  '旅Vlogと発信を始めたきっかけ',
  '旅Vlogや発信で心がけていること、伝えたいこと',
  'AYUMIさん流撮影方法やコツ',
  'AYUMIさん流編集方法やコツ'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      enquete: {
        video_sns_outgoing: null,
        sns_main_outgoing: null,
        sns_main_outgoing_other: null,
        shooting_equipment: null,
        shooting_equipment_other: null,
        camera_maker: null,
        sns_account: null,
        listen_detail: null
      }
    }
  },
  computed: {
    yesNo() {
      return YES_NO
    },
    snss() {
      return SNSS
    },
    equipments() {
      return EQUIPMENTS
    },
    contents() {
      return CONTENTS
    }
  },
  watch: {
    'enquete.video_sns_outgoing': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.sns_main_outgoing': {
      handler() {
        if (this.enquete.sns_main_outgoing !== 'その他') {
          this.enquete.sns_main_outgoing_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.shooting_equipment': {
      handler() {
        if (this.enquete.shooting_equipment !== 'その他') {
          this.enquete.shooting_equipment_other = null
        }
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.camera_maker': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.sns_account': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    },
    'enquete.listen_detail': {
      handler() {
        this.$cookies.set('entryEventEnquete', this.enquete)
      }
    }
  },
  mounted() {
    const enqueteCookie = this.$cookies.get('entryEventEnquete')
    if (enqueteCookie) {
      this.enquete = enqueteCookie
    }
  },
  methods: {
    isOtherRequired(id) {
      if (process.browser) {
        const element = document.getElementById(id)
        if (element) {
          return element.checked
        }
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.job-form-point {
  font-size: 0.85em;
  opacity: 0.9;
  line-height: 1.4;
}
</style>
